import React from 'react'

const Footer = () => {
    return (
        <footer className="w-full bg-indigo-950 shadow  dark:bg-grey-800 text-gray-600 ">

            <div className="xl:max-w-6xl mx-auto md:mx-6 lg:mx-10 xl:mx-auto py-4 lg:py-6  text-gray-300  items-center">
                <p className="text-sm mt-2 text-center  dark:text-gray-300  md:mt-0">
                    Made with<span className="animate-pulse"> ❤️ </span>by
                    <span className="text-violet-600 text-2xl">    Shriram Barai </span>
                </p>
            </div>

        </footer>
    )
}

export default Footer
